import styled, { css } from 'styled-components';
import { EBadgeVariant, EBadgeSize } from './config';

export const BadgeBase = styled.span<{
    $variant: EBadgeVariant;
    $size: EBadgeSize;
}>`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  border-radius: 9999px;
  font-weight: 500;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);

  /* Size variants */
  ${(props) =>
        props.$size === EBadgeSize.SM
            ? css`
          height: 20px;
          padding: 0 8px;
          font-size: 12px;
          line-height: 20px;
        `
            : css`
          height: 24px;
          padding: 0 10px;
          font-size: 14px;
          line-height: 24px;
        `}

  /* Variant styles */
  ${(props) => {
        switch (props.$variant) {
            case EBadgeVariant.SECONDARY:
                return css`
          background-color: hsl(220, 14%, 96%);
          color: hsl(224, 71%, 4%);
        `;
            case EBadgeVariant.DESTRUCTIVE:
                return css`
          background-color: hsl(0, 84%, 60%);
          color: white;
        `;
            case EBadgeVariant.OUTLINE:
                return css`
          background-color: transparent;
          border: 1px solid hsl(214, 32%, 91%);
          color: hsl(224, 71%, 4%);
        `;
            case EBadgeVariant.SUCCESS:
                return css`
          background-color: hsl(142, 72%, 29%);
          color: white;
        `;
            default:
                return css`
          background-color: hsl(221, 83%, 53%);
          color: white;
        `;
        }
    }}
`;